<app-app-update></app-app-update>

<router-outlet #outlet="outlet"></router-outlet>
